<template>
<div class="chapter">
<div class="inner_page">
<div class="section">
<div class="header">
<div class="hgroup">
<h3></h3>
<h1>Copyright</h1>
</div>
</div>
<p class="double" style="text-align: center;">
	Diversion Books<br/>
	A Division of Diversion Publishing Corp.<br/>
	443 Park Avenue South, Suite 1004<br/>
	New York, NY 10016<br/>
<a href="http://www.DiversionBooks.com" target="_blank">www.DiversionBooks.com</a></p>
<p class="double" style="text-align: center;">
	Copyright © 1989, 2009 by Anthony Bruno<br/>
	All rights reserved, including the right to reproduce this book or portions thereof in any form whatsoever.</p>
<p class="double" style="text-align: center;">
	This is a work of fiction. Names, characters, places and incidents either are the product of the author’s imagination or are used fictitiously. Any resemblance to actual persons, living or dead, events or locales is entirely coincidental.</p>
<p class="double" style="text-align: center;">
	For more information, email <a href="mailto:info@diversionbooks.com">info@diversionbooks.com</a></p>
<p style="text-align: center;">
	First Diversion Books edition January 2014<br/>
	ISBN: <span style="font-family: 'Liberation Serif', serif; font-size: 1em; line-height: 1.375; text-align: justify;">978-1-62681-228-4</span></p>
<div style="page-break-after: always;">
<div style="display: none;">
</div>
</div>
<h1>
	More from Anthony Bruno</h1>
<p class="sectiontop" style="text-align: center;">
<em><strong>Gibbons &amp; Tozzi Novels</strong></em></p>
<p class="first" style="text-align: center;">
<span href="#/chap220022" title="Link target outside of Sample">Bad Guys</span></p>
<p class="first" style="text-align: center;">
<span href="#/chap220022" title="Link target outside of Sample">Bad Blood</span></p>
<p class="first" style="text-align: center;">
<span href="#/chap220022" title="Link target outside of Sample">Bad Luck</span></p>
<p class="first" style="text-align: center;">
<span href="#/chap220022" title="Link target outside of Sample">Bad Business</span></p>
<p class="first" style="text-align: center;">
<span href="#/chap220022" title="Link target outside of Sample">Bad Moon</span></p>
<p class="first" style="text-align: center;">
<span href="#/chap220022" title="Link target outside of Sample">Bad Apple</span></p>
<p class="sectiontop" style="text-align: center;">
<em><strong>Loretta Kovacs Novels</strong></em></p>
<p class="first" style="text-align: center;">
	Devil’s Food</p>
<p class="first" style="text-align: center;">
	Double Espresso</p>
<p class="first" style="text-align: center;">
	Hot Fudge</p>
<p class="sectiontop" style="text-align: center;">
<em style="font-size: 1em; line-height: 1.5; text-indent: 0em;"><strong>The Temptations of St. Frank</strong></em></p>
<p class="first" style="text-align: center;">
<em style="font-size: 1em; line-height: 1.5; text-indent: 0em;"><strong>Bleeders</strong></em></p>
<div style="page-break-after: always;">
<div style="display: none;">
</div>
</div>
<p class="sectiontop" style="text-align: center;">
<em>FOR MY SWEETIE</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Copyright.vue?62cb240c